export default __webpack_public_path__ + "static/media/car-2.6b10560a.png";